(function () {
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const request = args[0];
    const url = request instanceof Request ? request.url : String(request);
    const isAddToCart = url.includes('/cart/add');
    const promise = originalFetch.apply(this, args);
    if (isAddToCart) {
      promise
        .then((response) => {
          if (response.ok) {
            window.location.href = '/cart';
          }
        })
        .catch(() => {});
    }
    return promise;
  };
})();
